import scan from "rfuncs/functions/scan"

import state from "../state/main"

export default (key, value) => scan(v => state[key].push(v), value)
